import React, { useEffect } from 'react';
import { canUseDOM } from '../../../utils';
import { ReactComponent as ChevronArrowDown } from '../../../resources/icons/chevron-bold.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
const CategoryTilesCard = _ref => {
  let {
    componentId,
    item,
    eventsAnalytics,
    params,
    index
  } = _ref;
  const calculateTitleBlockHeight = () => {
    const title = document.getElementById(`title${index}-${componentId}`);
    const information = document.getElementById(`information${index}-${componentId}`);
    const isDesktop = canUseDOM && window.matchMedia("(min-width: 1200px)").matches;
    if (information) {
      if (isDesktop) {
        information.style.maxHeight = title ? `${title.getBoundingClientRect().height}px` : "30px";
        return;
      }
      information.style.maxHeight = "initial";
    }
  };
  useEffect(() => {
    if (canUseDOM) {
      setTimeout(() => {
        calculateTitleBlockHeight();
      }, 300);
      window.addEventListener('resize', calculateTitleBlockHeight);
      document.addEventListener("resize", calculateTitleBlockHeight);
    }
    return () => {
      if (canUseDOM) {
        window.removeEventListener('resize', calculateTitleBlockHeight);
        document.removeEventListener("resize", calculateTitleBlockHeight);
      }
    };
  }, []);
  const analyticsImageHandler = e => {
    e.stopPropagation();
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageClickAnalytics'], params), item.title.jss.value);
  };
  const analyticsArrowHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ImageArrowClickAnalytics'], params), item.title.jss.value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "cardWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: item.image.jss.value.src,
    alt: item.image.jss.value.alt,
    className: "image",
    onClick: e => analyticsImageHandler(e)
  }), /*#__PURE__*/React.createElement("div", {
    className: "textContainer",
    onClick: e => analyticsImageHandler(e)
  }, /*#__PURE__*/React.createElement("div", {
    className: "information",
    id: `information${index}-${componentId}`
  }, /*#__PURE__*/React.createElement("p", {
    className: "title",
    id: `title${index}-${componentId}`
  }, item.title.jss.value), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, item.shortDescription.jss.value)), /*#__PURE__*/React.createElement("div", {
    className: "circleLink",
    onClick: analyticsArrowHandler
  }, /*#__PURE__*/React.createElement(ChevronArrowDown, {
    className: "arrowIcon"
  }))));
};
export { CategoryTilesCard };